import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/9ea0b2bf-9fc2-45cf-872a-fa331dd4e3df";
export const REGISTER_URL = "https://a.ntrk2.com/99f258bc-3a1e-44d3-8992-1a3795230eb3";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://bdrich.kzw2a.com/download?openExternalBrowser=1&id=jtgdh8inhodg3gb";

export * from "./codes";
export * from "./context";
